import React, { Component } from 'react'
import Button from '../../UI/Button/Button'
import { InputTextVal, InputCreditCard } from '../../UI/Input/Input'
import Select from '../../UI/Select/Select'
import { ONBOARDING_API } from '../../../constants/ApiConstants'
import axios from 'axios'
import adyenEncrypt from 'adyen-encryption'
import { SELECT_MONTHS_NUM } from '../../../constants/Months'
import { YEARS_CREDIT_CARD } from '../../../constants/Years'


export default class ClientPayment extends Component {
    constructor() {
        super()

        this.state = {
            creditCard: '',
            cvc: '',
            holderName: '',
            expiryMonth: '',
            expiryYear: '',
            variant: '',
            creditCardError: null,
            cvcError: null,
        }
    }

    handleChange = event => {
        const isCheckbox = event.target.type === 'checkbox'

        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value,
            creditCardError: null
        })
    }

    handleSelectChange = (name, val) => {
        this.setState({
            [name]: val
        })
    }

    getVariant(val) {
        this.setState({
            variant: val 
        })
    }

    getAdyenKey() {
        var lh = window.location.host;
        var env = '';
        var env3 = lh.includes("stg") || lh.includes("localhost")

        if (env3) {
            env = "10001|962E07E34EE4EC326A8C1D1EAA5C7A3F4ABEA4EA4E61568D8DDFA431E22BB678D97BFD7C900A39664EB0EEE79BE554E1F04FC24E50E7F59A7ED02174BEBE445D3937E0D55F0F243ADC34E729381D41CD24DCFA2B54929D03E936AEF161CAE5A023B4F1694CD5C0D0557EF115C80C3007BB44AE71308898094B635290A308CA3C64432610F058FE3B1A7DA1B0CA667A6F13921D4AE19885274E7D8AAB7B0105DA2057824F4AA64CB172247F5CD36E374706D38820A7C7813DBF4521AD08B7B9BACA0D9373E8D7565C38766BFA2EA778D67768696C16205056BC211F0C21B984843E624387AE59B90D353D4A7ECC23358302DBAFA7C13369EBFBC60C5F7EA00BF5";
            // env = "10001|9D7CF5DCE585828652D182FAD54C5C2502D5C9A9DC2099FF52774A3655D77F1DB63656D62C1259580EA34CB4B4FD0987866930CB92C8EF4ED979332BE6E1E86A81FA0B66F3C45E6064CF04FFBFA576F53E0CA9CF214DF21B8D0CB781C6E3613F4591ADFFF252496A12ED664CBDE5FC5ADD7A2419EFB2B2F9A87FFCD42FBCF3A3112FCC659EE0F9BFC46AA7E36C1374F17B3CE7A4368629A5D6BDB4F367680361C5EDEFF9A655CF6DF61420ADCA29FDF870A2F94A7760B12DFFC24EF8003BACB7559137A54160222CBE1E25B779A4B02307688643DB83C4ECB6B772194C868B51FF735D4A07B866245A998CDB1C534E2B2B87E8F621799985F62C01FDDCA2A637";
        } else {
            env = "10001|9D7CF5DCE585828652D182FAD54C5C2502D5C9A9DC2099FF52774A3655D77F1DB63656D62C1259580EA34CB4B4FD0987866930CB92C8EF4ED979332BE6E1E86A81FA0B66F3C45E6064CF04FFBFA576F53E0CA9CF214DF21B8D0CB781C6E3613F4591ADFFF252496A12ED664CBDE5FC5ADD7A2419EFB2B2F9A87FFCD42FBCF3A3112FCC659EE0F9BFC46AA7E36C1374F17B3CE7A4368629A5D6BDB4F367680361C5EDEFF9A655CF6DF61420ADCA29FDF870A2F94A7760B12DFFC24EF8003BACB7559137A54160222CBE1E25B779A4B02307688643DB83C4ECB6B772194C868B51FF735D4A07B866245A998CDB1C534E2B2B87E8F621799985F62C01FDDCA2A637";
        }

        return env;
    }

    sendClientePayment = event => {
        event.preventDefault()

        const companyId = sessionStorage.getItem('companyId')

        const key = this.getAdyenKey()
        let postEncrypt = null

        const cardData = {
            number: this.state.creditCard,
            cvc: this.state.cvc,
            holderName: this.state.holderName,
            expiryMonth: this.state.expiryMonth,
            expiryYear: this.state.expiryYear,
            generationtime : new Date()
        };

        adyenEncrypt.encrypt(key, cardData)
            .then(dataEncrypted => {
                //card data is secure now!
                postEncrypt = dataEncrypted

                const cardMasc = this.state.creditCard.substring(this.state.creditCard.length - 4)

                const req = {
                    creditCard: {
                        number: cardMasc,
                        holderName: this.state.holderName,
                        expirationMonth: this.state.expiryMonth,
                        expirationYear: this.state.expiryYear,
                        variant: this.state.variant,
                        encryptedCardData: postEncrypt
                    }
                }

                axios.post(`${ONBOARDING_API}${companyId}/payment-method`, req).then(resp => {
                    this.props.sendInfo(this, 5)
                }).catch(error => {
                    console.log(error.response.data.message)

                    let errorList = {
                        creditCardError: ''
                    }
        
                    for (let i in error.response.data.validations) {
                        const item = error.response.data.validations[i]
        
                        switch (item.field) {
                            case 'number':
                                errorList.creditCardError = item.message
                                break;
                            default:
                                break;
                        }
                    }
        
                    this.setState({
                        creditCardError: errorList.creditCardError
                    })
                })
            })
    }

    render() {
        return(
            <form action="clientInfo" autoComplete="none" className="payment-form">
                <div className="row">
                    <InputCreditCard
                        text="Número do cartão"
                        autoComplete="off"
                        mask="creditCard"
                        name="creditCard"
                        max="99999999"
                        maxLength={16}
                        onChange={this.handleChange}
                        value={this.state.creditCard}
                        error={this.state.creditCardError}
                        onBlur={this.getVariant.bind(this)}
                    ></InputCreditCard>
                </div>
                <div className="row">
                    <InputTextVal
                        type="text"
                        autoComplete={'off'}
                        onChange={this.handleChange}
                        value={this.state.holderName || ''}
                        focus={this.state.holderName && 'focus'}
                        name="holderName"
                        text="Nome (como consta no cartão)"
                    ></InputTextVal>
                </div>
                <div className="row label">
                    Vencimento:
                </div>
                <div className="row multi">
                    <div className="col">
                        <Select
                            label="Mês"
                            name="expiryMonth"
                            responseType={'string'}
                            onChange={this.handleSelectChange.bind(this, 'expiryMonth')}
                            value={this.state.expiryMonth}
                            options={SELECT_MONTHS_NUM}>
                        </Select>
                    </div>
                    <div className="col">
                        <Select
                            label="Ano"
                            name="expiryYear"
                            responseType={'string'}
                            onChange={this.handleSelectChange.bind(this, 'expiryYear')}
                            value={this.state.expiryYear}
                            options={YEARS_CREDIT_CARD}>
                        </Select>
                    </div>
                </div>
                <div className="row multi">
                    <InputTextVal
                        type="text"
                        autoComplete={'off'}
                        onChange={this.handleChange}
                        value={this.state.cvc || ''}
                        focus={this.state.cvc && 'focus'}
                        name="cvc"
                        text="Código de segurança"
                    ></InputTextVal>
                </div>
                <div className="options">
                    <Button
                        onClick={this.sendClientePayment.bind(this)}
                        disabled={
                            !this.state.creditCard ||
                            !this.state.cvc ||
                            !this.state.holderName ||
                            !this.state.expiryMonth ||
                            !this.state.expiryYear ||
                            this.state.creditCardError
                        }
                        text="Enviar"
                    ></Button>
                </div>
            </form>
        )
    }
}